import React from "react";
import PropTypes from "prop-types";

const Buttons = ({ onClick, active }) => (
  <div className="button-wrapper">
    <button type="button" onClick={() => onClick("keyNumbers")} className={active === "keyNumbers" ? "active" : ""}>
      Key Numbers
    </button>
    <button type="button" onClick={() => onClick("tariffs")} className={active === "tariffs" ? "active" : ""}>
      Tariffs
    </button>
    <button type="button" onClick={() => onClick("oda")} className={active === "oda" ? "active" : ""}>
      Official Development Assistance
    </button>
  </div>
);
export default Buttons;

Buttons.propTypes = {
  active: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
